// booking-calendar.js
document.addEventListener('DOMContentLoaded', function() {
  // Show the widget when the button is clicked
  var openBtn = document.getElementById('book-appointment-btn');
  var widget = document.getElementById('booking-calendar-widget');
  if (openBtn && widget) {
    openBtn.addEventListener('click', function() {
      widget.style.display = 'block';
      widget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // Add a close button
  if (widget && !document.getElementById('booking-calendar-close')) {
    var closeBtn = document.createElement('button');
    closeBtn.id = 'booking-calendar-close';
    closeBtn.textContent = '×';
    closeBtn.setAttribute('aria-label', 'Close booking calendar');
    closeBtn.style.cssText = 'position:absolute;top:8px;right:8px;font-size:1.5em;background:none;border:none;cursor:pointer;color:#fe537b;';
    closeBtn.onclick = function() { widget.style.display = 'none'; };
    widget.style.position = 'relative';
    widget.insertBefore(closeBtn, widget.firstChild);
  }

  // Parse metafield for staff availability (multiple entries)
  const staffAvailabilityArray = window.staffAvailabilityArray || [];
  console.log('[Booking Calendar] staffAvailability:', staffAvailabilityArray);

  // Parse all on_trip, partial, and out_all_day entries
  let tripRanges = [];
  let partials = [];
  let outAllDays = [];
  staffAvailabilityArray.forEach(entry => {
    if (entry.startsWith('on_trip:')) {
      const m = entry.match(/on_trip:(\d{4}-\d{2}-\d{2}):(\d{4}-\d{2}-\d{2})/);
      if (m) tripRanges.push({ start: m[1], end: m[2] });
    } else if (entry.startsWith('partial:')) {
      // Normalize all dashes to hyphen and trim spaces
      let partialMeta = entry.replace(/[\u2013\u2014]/g, '-').replace(/\s*-\s*/g, '-');
      // Try 24h format first
      let m = partialMeta.match(/partial:(\d{1,2}:\d{2})-(\d{1,2}:\d{2}):(\d{4}-\d{2}-\d{2})/);
      if (m) {
        partials.push({ start: m[1], end: m[2], date: m[3], format: '24h' });
      } else {
        // Try AM/PM format, any case, any spacing
        m = partialMeta.match(/partial:(\d{1,2}\s*[aApP][mM])-(\d{1,2}\s*[aApP][mM]):(\d{4}-\d{2}-\d{2})/);
        if (m) {
          function normalizeAMPM(str) {
            return str.replace(/\s+/g, '').replace(/([aApP][mM])$/, function(x) { return x.toUpperCase(); });
          }
          partials.push({ start: normalizeAMPM(m[1]), end: normalizeAMPM(m[2]), date: m[3], format: 'ampm' });
        }
      }
    } else if (entry.startsWith('out_all_day:')) {
      const m = entry.match(/out_all_day:(\d{4}-\d{2}-\d{2})/);
      if (m) outAllDays.push(m[1]);
    }
  });
  console.log('[Booking Calendar] tripRanges:', tripRanges);
  console.log('[Booking Calendar] partials:', partials);
  console.log('[Booking Calendar] outAllDays:', outAllDays);

  const dateInput = document.getElementById('booking-calendar-date');
  const slotSelect = document.getElementById('booking-calendar-slot');
  const bookBtn = document.getElementById('booking-calendar-book');
  const msgDiv = document.getElementById('booking-calendar-message');

  // Parse metafield for booked slots (from window.bookedSlotsString, multiline text)
  let bookedSlots = {};
  let bookedSlotsRaw = window.bookedSlotsString;
  if (typeof bookedSlotsRaw !== 'string') bookedSlotsRaw = '';
  let bookedSlotLines = bookedSlotsRaw.split(/[\r\n]+/).map(s => s.trim()).filter(Boolean);
  let bookedSlotObjects = [];
  bookedSlotLines.forEach(function(slotStr) {
    // slotStr: 'YYYY-MM-DD HH:MM|duration' or 'YYYY-MM-DD HH:MM'
    const [dateTime, durationStr] = slotStr.split('|');
    const parts = dateTime.split(' ');
    if (parts.length === 2) {
      const date = parts[0];
      const time = parts[1];
      const duration = durationStr ? parseInt(durationStr, 10) : 30; // default 30 min
      if (!bookedSlots[date]) bookedSlots[date] = [];
      bookedSlots[date].push({ time, duration });
      bookedSlotObjects.push({ date, time, duration });
    }
  });
  console.log('[Booking Calendar] bookedSlots:', bookedSlots);

  // Helper: is date in trip range?
  function isDateInRange(dateStr, start, end) {
    const d = new Date(dateStr + 'T00:00:00Z');
    const s = new Date(start + 'T00:00:00Z');
    const e = new Date(end + 'T00:00:00Z');
    return d >= s && d <= e;
  }

  // Helper: convert AM/PM to 24h
  function ampmTo24h(str) {
    // Accepts e.g. '1PM', '1 pm', '01 Pm', '01pM', etc.
    let m = str.match(/(\d{1,2})\s*([aApP][mM])/);
    if (!m) return null;
    let h = parseInt(m[1], 10);
    let ap = m[2].toUpperCase();
    if (ap === 'AM') return h === 12 ? 0 : h;
    if (ap === 'PM') return h === 12 ? 12 : h + 12;
    return null;
  }

  // Helper: is slot in partial range?
  function isSlotInPartial(slot, partial) {
    // slot: '14:00', partial: {start, end, date, format}
    function toMinutes(t) {
      const [h, m] = t.split(':');
      return parseInt(h, 10) * 60 + parseInt(m, 10);
    }
    let slotStart = toMinutes(slot);
    let slotEnd = slotStart + (window.bookingSlotMinutes || 30);

    let startMins, endMins;
    if (partial.format === '24h') {
      startMins = toMinutes(partial.start);
      endMins = toMinutes(partial.end);
    } else if (partial.format === 'ampm') {
      startMins = ampmTo24h(partial.start) * 60;
      endMins = ampmTo24h(partial.end) * 60;
    } else {
      return true;
    }
    // Only allow slots that are fully within the partial window
    return slotStart >= startMins && slotEnd <= endMins;
  }

  // Helper: is slot in the future (for today)?
  function isSlotInFuture(slot, dateStr) {
    const now = new Date();
    const localDate = new Date(dateStr + 'T00:00:00');
    if (now.toLocaleDateString('en-CA') !== dateStr) return true;
    // slot: '14:00'
    const [h, m] = slot.split(':');
    const slotTime = new Date(localDate);
    slotTime.setHours(parseInt(h, 10), parseInt(m, 10), 0, 0);
    return slotTime > now;
  }

  // Generate slots
  function getSlots() {
    const slotMinutes = window.bookingSlotMinutes || 30;
    const slots = [];
    for (let mins = 11*60; mins < 18*60; mins += slotMinutes) {
      const h = Math.floor(mins/60);
      const m = mins%60;
      const label = `${h.toString().padStart(2,'0')}:${m===0?'00':m.toString().padStart(2,'0')}`;
      slots.push(label);
    }
    return slots;
  }

  // Update helpers and logic to use arrays
  function isDateInAnyTripRange(dateStr) {
    return tripRanges.some(range => isDateInRange(dateStr, range.start, range.end));
  }
  function isDateOutAllDay(dateStr) {
    return outAllDays.includes(dateStr);
  }
  function getPartialsForDate(dateStr) {
    return partials.filter(p => p.date === dateStr);
  }

  // Helper to check if two time intervals overlap
  function slotsOverlap(slot1, dur1, slot2, dur2) {
    // slot: 'HH:MM', dur: minutes
    function toMinutes(t) {
      const [h, m] = t.split(':');
      return parseInt(h, 10) * 60 + parseInt(m, 10);
    }
    const start1 = toMinutes(slot1);
    const end1 = start1 + dur1;
    const start2 = toMinutes(slot2);
    const end2 = start2 + dur2;
    return Math.max(start1, start2) < Math.min(end1, end2);
  }

  function showSlotsForDate(dateStr) {
    // Block out_all_day
    if (isDateOutAllDay(dateStr)) {
      slotSelect.style.display = 'none';
      bookBtn.style.display = 'none';
      msgDiv.textContent = 'Staff is out all day and unavailable for booking on this date.';
      return;
    }
    let slots = getSlots();
    // If today, only show future slots
    const todayStr = new Date().toLocaleDateString('en-CA');
    if (dateStr === todayStr) {
      slots = slots.filter(slot => isSlotInFuture(slot, dateStr));
    }
    // If partial applies, only show allowed slots (support multiple partials for a date)
    const partialsForDate = getPartialsForDate(dateStr);
    if (partialsForDate.length > 0) {
      slots = slots.filter(slot => partialsForDate.some(partial => isSlotInPartial(slot, partial)));
    }
    // Block booked slots for this date (block all overlapping slots)
    if (bookedSlots[dateStr]) {
      console.log('Slots for date', dateStr, slots);
      console.log('Booked slots for date', bookedSlots[dateStr]);
      slots = slots.filter(slot => {
        return !bookedSlots[dateStr].some(b => slotsOverlap(slot, window.bookingSlotMinutes, b.time, b.duration));
      });
      console.log('Available slots after filtering', slots);
    }
    if (slots.length === 0) {
      slotSelect.style.display = 'none';
      bookBtn.style.display = 'none';
      msgDiv.textContent = 'No available slots for this date.';
      return;
    }
    slotSelect.innerHTML = '<option value="">Select time slot</option>' + slots.map(s => `<option value="${s}">${s}</option>`).join('');
    slotSelect.style.display = 'block';
    bookBtn.style.display = 'none';
  }

  // --- Flatpickr integration ---
  function setupFlatpickr() {
    if (typeof flatpickr === 'undefined') return false;
    flatpickr(dateInput, {
      dateFormat: 'Y-m-d',
      minDate: 'today',
      disable: [
        function(date) {
          const y = date.getFullYear();
          const m = (date.getMonth()+1).toString().padStart(2,'0');
          const d = date.getDate().toString().padStart(2,'0');
          const dateStr = `${y}-${m}-${d}`;
          // Disable Sundays
          if (date.getDay() === 0) return true;
          // Disable on_trip ranges
          if (isDateInAnyTripRange(dateStr)) return true;
          // Disable out_all_day
          if (isDateOutAllDay(dateStr)) return true;
          return false;
        }
      ],
      onChange: function(selectedDates, dateStr) {
        msgDiv.textContent = '';
        if (!dateStr) return;
        showSlotsForDate(dateStr);
      }
    });
    return true;
  }

  // --- Fallback: native date input ---
  function setupNativeDate() {
    dateInput.addEventListener('focus', function() {
      dateInput.type = 'date';
    });
    dateInput.addEventListener('blur', function() {
      if (!dateInput.value) dateInput.type = 'text';
    });
    dateInput.addEventListener('change', function() {
      msgDiv.textContent = '';
      const dateStr = dateInput.value;
      if (!dateStr) return;
      // Check out_all_day
      if (isDateOutAllDay(dateStr)) {
        msgDiv.textContent = 'Staff is out all day and unavailable for booking on this date.';
        slotSelect.style.display = 'none';
        bookBtn.style.display = 'none';
        return;
      }
      // Check trip ranges
      if (isDateInAnyTripRange(dateStr)) {
        msgDiv.textContent = 'Staff is on a trip and unavailable for booking on this date.';
        slotSelect.style.display = 'none';
        bookBtn.style.display = 'none';
        return;
      }
      // Block Sundays
      const d = new Date(dateStr + 'T00:00:00Z');
      if (d.getDay() === 0) {
        msgDiv.textContent = 'Staff is unavailable on Sundays.';
        slotSelect.style.display = 'none';
        bookBtn.style.display = 'none';
        return;
      }
      showSlotsForDate(dateStr);
    });
  }

  // --- Init ---
  if (!setupFlatpickr()) {
    setupNativeDate();
  }

  // Ensure hidden inputs for line item properties exist
  var bookingDateInput = document.getElementById('booking-date-input');
  if (!bookingDateInput) {
    bookingDateInput = document.createElement('input');
    bookingDateInput.type = 'hidden';
    bookingDateInput.name = 'properties[Booking Date]';
    bookingDateInput.id = 'booking-date-input';
    var form = document.querySelector('form[action^="/cart/add"]');
    if (form) form.appendChild(bookingDateInput);
  }
  var bookingSlotInput = document.getElementById('booking-slot-input');
  if (!bookingSlotInput) {
    bookingSlotInput = document.createElement('input');
    bookingSlotInput.type = 'hidden';
    bookingSlotInput.name = 'properties[Booking Slot]';
    bookingSlotInput.id = 'booking-slot-input';
    var form = document.querySelector('form[action^="/cart/add"]');
    if (form) form.appendChild(bookingSlotInput);
  }

  slotSelect.addEventListener('change', function() {
    bookBtn.style.display = slotSelect.value ? 'inline-block' : 'none';
    msgDiv.textContent = '';
  });

  bookBtn.addEventListener('click', function() {
    if (!dateInput.value || !slotSelect.value) {
      msgDiv.textContent = 'Please select a date and time slot.';
      return;
    }
    // Set hidden inputs for line item properties
    bookingDateInput.value = dateInput.value;
    bookingSlotInput.value = slotSelect.value;
    // Submit the Add to Cart form automatically
    var form = document.querySelector('form[action^="/cart/add"]');
    if (form) {
      form.submit();
    } else {
      msgDiv.textContent = 'Could not find the Add to Cart form.';
    }
  });

  // Hide the Book Appointment button if booked=1 is in the URL
  var params = new URLSearchParams(window.location.search);
  if (params.get('booked') === '1') {
    var bookBtnEl = document.getElementById('book-appointment-btn');
    if (bookBtnEl) bookBtnEl.style.display = 'none';
    if (widget) widget.style.display = 'none';
  }
});